import React, { useEffect } from 'react';
import { InquiryPayload } from '../types';

interface PublicInquiryFormProps {
  onSuccess: () => void;
  initialData?: InquiryPayload | null;
  onClearData?: () => void;
}

export const PublicInquiryForm: React.FC<PublicInquiryFormProps> = ({ onSuccess, initialData, onClearData }) => {
  
  // This safely loads the GoHighLevel script into your React app
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://go.quikpix.co.nz/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="w-full max-w-4xl mx-auto py-4 animate-fade-in-up">
      <iframe
        src="https://go.quikpix.co.nz/widget/form/7ARllu64T4qR5hAoUxIW"
        style={{ width: '100%', height: '1175px', border: 'none', borderRadius: '3px' }}
        id="inline-7ARllu64T4qR5hAoUxIW"
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Website Enquiry Form - React Website"
        data-height="1175"
        data-layout-iframe-id="inline-7ARllu64T4qR5hAoUxIW"
        data-form-id="7ARllu64T4qR5hAoUxIW"
        title="Website Enquiry Form - React Website"
      />
    </div>
  );
}; 

 